export const myTechnologies = [
  'Next',
  'React',
  'Tailwind',
  'Typescript',
  'Javascript',
  'Figma',
  'HTML',
  'CSS',
  'Bootstrap',
  'Wordpress',
  'Photoshop',
  'Node',
  'Bash'
];
